(() => {
  const llEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const initialise = () => {
    const nav = document.querySelector('[data-ll-home-nav]');
    if (nav && nav.dataset.scrollNav !== 'true') {
      nav.dataset.scrollNav = 'true';
      const updateNav = () => nav.classList.toggle('ll-home-nav--scrolled', window.scrollY > 40);
      updateNav();
      window.addEventListener('scroll', updateNav, { passive: true });

      const toggle = nav.querySelector('[data-ll-nav-toggle]');
      const setMenuOpen = (isOpen) => {
        nav.classList.toggle('is-menu-open', isOpen);
        document.body.classList.toggle('ll-mobile-menu-open', isOpen);
        if (toggle) {
          toggle.setAttribute('aria-expanded', String(isOpen));
          toggle.querySelector('.visually-hidden').textContent = isOpen ? (llEnglish ? 'Close menu' : 'メニューを閉じる') : (llEnglish ? 'Open menu' : 'メニューを開く');
        }
      };

      if (toggle) {
        toggle.addEventListener('click', () => setMenuOpen(!nav.classList.contains('is-menu-open')));
        nav.querySelectorAll('.ll-home-nav__links a').forEach((link) => link.addEventListener('click', () => setMenuOpen(false)));
        window.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') setMenuOpen(false);
        });
        window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
          if (event.matches) setMenuOpen(false);
        });
      }
    }

    document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;

      const track = carousel.querySelector('.ll-home-product__track');
      const slides = Array.from(track.querySelectorAll('.ll-home-product__slide'));
      const indicators = Array.from(carousel.querySelectorAll('[data-product-slide]'));
      const previous = carousel.querySelector('.ll-home-product__control--prev');
      const next = carousel.querySelector('.ll-home-product__control--next');
      if (!track || slides.length < 2 || !previous || !next) return;

      let current = 0;
      let visualIndex = 1;
      let pendingReset = null;
      let pointerStartX = null;
      let pointerDistance = 0;
      let pointerId = null;
      let preventClick = false;
      let autoplay = null;
      const autoplayDelay = 5000;

      const makeClone = (slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.inert = true;
        return clone;
      };

      track.prepend(makeClone(slides[slides.length - 1]));
      track.append(makeClone(slides[0]));
      carousel.dataset.carouselReady = 'true';

      const render = () => {
        slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== current)));
        indicators.forEach((indicator, index) => {
          const isCurrent = index === current;
          indicator.setAttribute('aria-current', String(isCurrent));
          indicator.classList.remove('is-playing');
          if (isCurrent) {
            void indicator.offsetWidth;
            indicator.classList.add('is-playing');
          }
        });
      };

      const setPosition = (animated = true) => {
        track.classList.toggle('is-resetting', !animated);
        track.style.transform = `translateX(-${visualIndex * 100}%)`;
        if (!animated) {
          void track.offsetWidth;
          track.classList.remove('is-resetting');
        }
      };

      const startAutoplay = () => {
        carousel.classList.remove('is-paused');
        window.clearInterval(autoplay);
        autoplay = window.setInterval(() => move(1), autoplayDelay);
      };

      const stopAutoplay = () => {
        carousel.classList.add('is-paused');
        window.clearInterval(autoplay);
      };

      const move = (direction) => {
        if (pendingReset !== null) return;
        if (direction > 0) {
          if (current === slides.length - 1) {
            current = 0;
            visualIndex = slides.length + 1;
            pendingReset = 1;
          } else {
            current += 1;
            visualIndex = current + 1;
          }
        } else if (current === 0) {
          current = slides.length - 1;
          visualIndex = 0;
          pendingReset = slides.length;
        } else {
          current -= 1;
          visualIndex = current + 1;
        }
        render();
        setPosition();
        startAutoplay();
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      indicators.forEach((indicator, index) => indicator.addEventListener('click', () => {
        if (pendingReset !== null) return;
        current = index;
        visualIndex = current + 1;
        render();
        setPosition();
        startAutoplay();
      }));

      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') move(-1);
        if (event.key === 'ArrowRight') move(1);
      });

      carousel.addEventListener('pointerdown', (event) => {
        if (pendingReset !== null || (event.pointerType === 'mouse' && event.button !== 0) || event.target.closest('button, a')) return;
        pointerStartX = event.clientX;
        pointerDistance = 0;
        pointerId = event.pointerId;
        track.classList.add('is-dragging');
        carousel.setPointerCapture(pointerId);
        stopAutoplay();
      });

      carousel.addEventListener('pointermove', (event) => {
        if (pointerStartX === null || event.pointerId !== pointerId) return;
        pointerDistance = event.clientX - pointerStartX;
        track.style.transform = `translateX(calc(-${visualIndex * 100}% + ${pointerDistance}px))`;
      });

      const finishDrag = (event, cancelled = false) => {
        if (pointerStartX === null || (event && event.pointerId !== pointerId)) return;
        track.classList.remove('is-dragging');
        preventClick = !cancelled && Math.abs(pointerDistance) > 6;
        if (preventClick) window.setTimeout(() => { preventClick = false; }, 0);
        if (!cancelled && Math.abs(pointerDistance) > carousel.clientWidth * 0.18) move(pointerDistance < 0 ? 1 : -1);
        else {
          setPosition();
          startAutoplay();
        }
        pointerStartX = null;
        pointerId = null;
      };

      carousel.addEventListener('pointerup', (event) => finishDrag(event));
      carousel.addEventListener('pointercancel', () => finishDrag(null, true));
      track.addEventListener('transitionend', (event) => {
        if (event.target !== track || event.propertyName !== 'transform' || pendingReset === null) return;
        visualIndex = pendingReset;
        pendingReset = null;
        setPosition(false);
      });
      carousel.addEventListener('click', (event) => {
        if (!preventClick) return;
        event.preventDefault();
        event.stopPropagation();
        preventClick = false;
      }, true);
      carousel.addEventListener('pointerenter', stopAutoplay);
      carousel.addEventListener('pointerleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) startAutoplay();
      });

      render();
      setPosition(false);
      startAutoplay();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
